import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PauseFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.5 5C3.5 4.0335 4.2835 3.25 5.25 3.25H8.25C9.2165 3.25 10 4.0335 10 5V19C10 19.9665 9.2165 20.75 8.25 20.75H5.25C4.2835 20.75 3.5 19.9665 3.5 19V5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 5C14 4.0335 14.7835 3.25 15.75 3.25H18.75C19.7165 3.25 20.5 4.0335 20.5 5V19C20.5 19.9665 19.7165 20.75 18.75 20.75H15.75C14.7835 20.75 14 19.9665 14 19V5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PauseFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PauseFilledIcon;
